<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      processing: false,
    };
  },
  created: function () {
    this.$http.interceptors.response.use(undefined, (err) => {
      return new Promise(() => {
        if (
          err.toString().includes("403") &&
          this.$router.currentRoute.name != "Login"
        ) {
          if (!this.processing) {
            this.processing = true;
            this.$user.dispatch("logout").then(() => {
              this.processing = false;
              let returnUrl = this.$router.currentRoute.fullPath;
              let query = returnUrl ? { returnUrl } : null;
              this.$router.push({ name: "Login", query });
            });
          }

          return;
        }
        throw err;
      });
    });
  },
  async mounted() {
    let allowAccess = await this.checkRole();
    if (!allowAccess) {
      this.$router.push({ name: "Page404" });
    }
  },
  methods: {
    async checkRole() {
      let result = false;
      let resp = await this.$http.get(`odata/SipUserRole`, {
        params: {
          $top: 1,
          $select: "UserId,RoleCode",
          $expand: "User($select=Email,Name,Company),Area($select=Name)",
        },
      });
      if (
        resp &&
        resp.status == 200 &&
        resp.data &&
        resp.data.value &&
        resp.data.value.length
      ) {
        result = true;
        let record = resp.data.value[0];
        let sipUser = {
          UserId: record.UserId,
          FullName: record.User.Name,
          Email: record.User.Email,
          Company: record.User.Company,
          RoleCode: record.RoleCode,
          AreaName: record.Area ? record.Area.Name : null,
        };
        localStorage.setItem("sipUser", JSON.stringify(sipUser));
      } else {
        localStorage.removeItem("sipUser");
      }
      return result;
    },
  },
};
</script>

<style lang="scss">
// Import Main styles for this application
@import "assets/scss/style";
@import "vue-select/src/scss/vue-select.scss";

.v-select {
  .vs__dropdown-toggle {
    min-height: calc(1.5em + 0.75rem + 2px);
    padding-top: 3px;
  }
}
</style>
